var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.disabledCondition
      ? 'btn-disabled'
      : _vm.dangerCondition
      ? 'btn-danger dark'
      : _vm.warningCondition
      ? 'btn-attention'
      : 'btn-primary',attrs:{"disabled":_vm.disabledCondition,"title":_vm.disabledCondition ? _vm.disabledText : _vm.dangerCondition ? _vm.dangerText : null},on:{"click":function($event){_vm.disabledCondition || _vm.dangerCondition ? null : _vm.buttonClicked()}}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.buttonDescription))])])}
var staticRenderFns = []

export { render, staticRenderFns }